<template>
  <div
    class="app-input-row app-input-validator"
    :class="{ error: errors?.length }"
  >
    <slot></slot>
    <div v-for="error of props.errors" :key="error.$uid" class="input-errors">
      <div class="error-message">{{ error.$message }}</div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  errors: Array,
})
</script>
